<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import HorizontalContentRow from '../components/HorizontalContentRow.vue';
import HorizontalContentRowHeader from '../components/HorizontalContentRowHeader.vue';
import { useRouter } from 'vue-router';
import NoteSVG from '@shared/assets/icon/danger.svg';

const router = useRouter();

function goToEnterSerialNumber() {
  router.push({ name: 'SerialNumberHow' });
}
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <template #title>To begin, we need to startup your SolShare.</template>

    <HorizontalContentRowHeader>
      <div class="row-header-text">
        Follow steps in the SolShare startup procedure on site to energise SolShare via all tenancy
        connections.
        <br />A typical procedure involves:
      </div>
    </HorizontalContentRowHeader>

    <HorizontalContentRow firstRow lastRow>
      <div class="steps-container">
        <div class="steps-list">
          <div class="step-item">
            <span class="step-number">1.</span>
            <span class="step-text">Ensure MAIN SWITCH (NORMAL) for each tenancy is on.</span>
          </div>
          <div class="step-item">
            <span class="step-number">2.</span>
            <span class="step-text"
              >Turn on MAIN SWITCH (INVERTER) for each tenancy connected to SolShare.</span
            >
          </div>
          <div class="step-item">
            <span class="step-number">3.</span>
            <span class="step-text">Turn on all SOLSHARE, A.C. ISOLATORS (GRID).</span>
          </div>
        </div>
        <div class="note-container">
          <div class="icon-container">
            <NoteSVG class="note-icon" aria-hidden="true" />
          </div>
          <div class="note-text">
            <p>
              NOTE: During SolShare commissioning process, the inverter must be isolated from
              SolShare. Typically, this means:
              <br />INVERTER ISOLATOR is OFF
            </p>
          </div>
        </div>
      </div>
    </HorizontalContentRow>

    <div class="button-container">
      <ButtonPrimary block @click="goToEnterSerialNumber" data-tn="startup-solshare-done">
        Done
      </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.row-header-text {
  padding: 0 @content-side-margin;
}

.steps-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 0.57rem;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 0.57rem;
  font-size: 1rem;
}

.step-number {
  color: @color-primary;
  font-weight: @font-weight-medium;
}

.step-text {
  line-height: 1.4;
}

.button-container {
  padding: 0 @content-side-margin 1.14rem;
}

.note-container {
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 1rem;

  .icon-container {
    flex-shrink: 0;

    .note-icon {
      width: 1.8rem;
      height: 1.8rem;
    }
  }

  .note-text {
    font-size: 1rem;
    line-height: 1.4;
    color: @color-primary;
    flex: 1 1 auto;
  }
}
</style>
